import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  label: {
    id: 'GoogleAuthButton.label',
    defaultMessage: 'Sign in with Google',
  },
})
